var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.18 20.04v.74m0 0c0 1-.63 1.64-1.41 1.64-.78 0-1.42-.64-1.42-1.64v-2.2c.33-2-3.57-1.87-3.57-8.28 0-4.82 4.13-8.72 9.22-8.72 5.1 0 9.22 3.9 9.22 8.72 0 6.43-3.9 6.2-3.57 8.42v2.06c0 1-.64 1.64-1.42 1.64-.77 0-1.4-.64-1.4-1.64m-5.65 0c0 1 .63 1.64 1.4 1.64.79 0 1.42-.64 1.42-1.64m0-.74v.74m0 0c0 1 .63 1.64 1.41 1.64.78 0 1.41-.64 1.41-1.64m0-.74v.74m-2.56-6.21c.67 0 1.24.87 1.43 1.67.06.23-.18.38-.38.26a2.08 2.08 0 0 0-1.05-.3m0-1.63c-.68 0-1.25.88-1.45 1.68-.05.23.18.38.38.27.4-.21.74-.32 1.07-.32m0-1.63v1.63m6.13-5.25a2.58 2.58 0 0 0-5.14 0 2.58 2.58 0 0 0 5.14 0Zm-7.75 0a2.58 2.58 0 0 0-5.14 0 2.58 2.58 0 0 0 5.14 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.6603c5817744efcded2a8ec7b62cab20.svg";
export { ForwardRef as ReactComponent };